
import { defineComponent, PropType } from 'vue'

import { VcsProviderChoices } from '~/types/types'

const providerClassMap: Partial<Record<VcsProviderChoices, string>> = {
  [VcsProviderChoices.Github]: 'github',
  [VcsProviderChoices.GithubEnterprise]: 'github',
  [VcsProviderChoices.Gitlab]: 'gitlab',
  [VcsProviderChoices.Bitbucket]: 'bitbucket',
  [VcsProviderChoices.BitbucketDatacenter]: 'bitbucket',
  [VcsProviderChoices.Ads]: 'ads'
}

export default defineComponent({
  name: 'AuthProviderButton',
  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    provider: {
      type: String as PropType<VcsProviderChoices>,
      required: true
    },
    href: {
      type: String,
      default: undefined
    },
    type: {
      type: String,
      default: 'button',
      validator(val: string) {
        return ['submit', 'reset', 'button'].includes(val)
      }
    },
    fullWidth: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    iconSize: {
      type: String,
      default: 'base'
    },
    iconColor: {
      type: String,
      default: ''
    }
  },
  computed: {
    isLink(): boolean {
      return Boolean(this.href)
    },
    componentTag(): string {
      return this.isLink ? 'a' : 'button'
    },
    providerClass(): string {
      const suffix = providerClassMap[this.provider]
      return suffix ? `auth-provider-btn--${suffix}` : ''
    },
    iconColorComputed(): string | undefined {
      return this.iconColor || undefined
    }
  },
  methods: {
    handleClick(event: Event): void {
      if (this.disabled) {
        event.preventDefault()
        event.stopPropagation()
        return
      }
      this.$emit('click', event)
    }
  }
})
